export default __webpack_public_path__ + "static/img-app-training--mobile-d4988311300053ccaf4f9ca065e6f0ae.webp";